import api from './api';

export interface CreateUserRequest {
  login: string;
  password: string;
  type: 'admin' | 'manager' | 'client' | 'salary';
  agentId: number;
  category?: number;
  salaryCategories?: number[];
  ukIds?: string[];
  sourceIds?: string[];
  disableRewards?: boolean;
}

export interface UpdateUserRequest {
  id: string;
  login?: string;
  password?: string;
  type?: 'admin' | 'manager' | 'client' | 'salary';
  agentId?: number;
  category?: number;
  salaryCategories?: number[];
  ukIds?: string[];
  sourceIds?: string[];
  disableRewards?: boolean;
}

export interface CreateTariffRequest {
  name: string;
  ukIds?: string[]; // Опционально - можно создать тариф только с источниками
  waterRate?: number;
  heatRate?: number;
  gasRate?: number;
  description?: string;
  sourceIds: string[];
  products?: Array<{
    productId: string;
    rate: number;
    rateType: 'fixed' | 'percentage';
  }>;
}

export interface UpdateTariffRequest {
  id: string;
  name?: string;
  ukIds?: string[];
  waterRate?: number;
  heatRate?: number;
  gasRate?: number;
  description?: string;
  isActive?: boolean;
  sourceIds?: string[];
  products?: Array<{
    productId: string;
    rate: number;
    rateType: 'fixed' | 'percentage';
  }>;
}

export interface CreateProductRequest {
  name: string;
  type: 'water' | 'warm' | 'gas' | 'other';
  description?: string;
  isHidden?: boolean;
  hiddenForClientIds?: string[];
}

export interface UpdateProductRequest {
  id: string;
  name?: string;
  type?: 'water' | 'warm' | 'gas' | 'other';
  description?: string;
  isActive?: boolean;
  isHidden?: boolean;
  hiddenForClientIds?: string[];
}

export interface Source {
  id: string;
  name: string;
  sort: number;
  statusId: string;
}

export interface UK {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUKRequest {
  name: string;
}

export interface UpdateUKRequest {
  name?: string;
  isActive?: boolean;
}

export interface CreateSourceRequest {
  name: string;
  sort: number;
  statusId: string;
}

export interface UpdateSourceRequest {
  id: string;
  name?: string;
  sort?: number;
  statusId?: string;
}

export interface CreateGeneralTariffRequest {
  name: string;
  waterRate?: number;
  heatRate?: number;
  gasRate?: number;
  products?: Array<{
    productId: string;
    rate: number;
    rateType: 'fixed' | 'percentage';
  }>;
}

export interface UpdateGeneralTariffRequest {
  name?: string;
  waterRate?: number;
  heatRate?: number;
  gasRate?: number;
  products?: Array<{
    productId: string;
    rate: number;
    rateType: 'fixed' | 'percentage';
  }>;
}

export const adminApi = {
  // Управление пользователями
  getUsers: () => api.get('/api/v1/admin/users'),
  createUser: (data: CreateUserRequest) => api.post('/api/v1/admin/users', data),
  updateUser: (data: UpdateUserRequest) => {
    const { id, ...updateData } = data;
    return api.put(`/api/v1/admin/users/${id}`, updateData);
  },
  deleteUser: (id: string) => api.delete(`/api/v1/admin/users/${id}`),

  // Управление тарифами
  getTariffs: () => api.get('/api/v1/admin/tariffs'),
  createTariff: (data: CreateTariffRequest) => api.post('/api/v1/admin/tariffs', data),
  updateTariff: (data: UpdateTariffRequest) => {
    const { id, ...updateData } = data;
    return api.put(`/api/v1/admin/tariffs/${id}`, updateData);
  },
  deleteTariff: (id: string) => api.delete(`/api/v1/admin/tariffs/${id}`),
  getSources: () => api.get('/api/v1/admin/sources'),
  createSource: (data: CreateSourceRequest) => api.post('/api/v1/admin/sources', data),
  updateSource: (data: UpdateSourceRequest) => {
    const { id, ...updateData } = data;
    return api.put(`/api/v1/admin/sources/${id}`, updateData);
  },
  deleteSource: (id: string) => api.delete(`/api/v1/admin/sources/${id}`),

  // Управление товарами
  getProducts: () => api.get('/api/v1/admin/products'),
  createProduct: (data: CreateProductRequest) => api.post('/api/v1/admin/products', data),
  updateProduct: (data: UpdateProductRequest) => {
    const { id, ...updateData } = data;
    return api.put(`/api/v1/admin/products/${id}`, updateData);
  },
  deleteProduct: (id: string) => api.delete(`/api/v1/admin/products/${id}`),

  // Управление УК
  getUKs: () => api.get('/api/v1/admin/uks'),
  createUK: (data: CreateUKRequest) => api.post('/api/v1/admin/uks', data),
  updateUK: (data: UpdateUKRequest & { id: string }) => {
    const { id, ...updateData } = data;
    return api.put(`/api/v1/admin/uks/${id}`, updateData);
  },
  deleteUK: (id: string) => api.delete(`/api/v1/admin/uks/${id}`),

  // Управление общим тарифом
  getGeneralTariff: () => api.get('/api/v1/admin/general-tariff'),
  createGeneralTariff: (data: CreateGeneralTariffRequest) => api.post('/api/v1/admin/general-tariff', data),
  updateGeneralTariff: (data: UpdateGeneralTariffRequest) => api.put('/api/v1/admin/general-tariff', data),
  deleteGeneralTariff: () => api.delete('/api/v1/admin/general-tariff'),
};
